// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"2d7f22b0","594":"8c181af5","606":"95e05844","746":"1e12271a","844":"5015f33f","886":"900ede25","929":"b8955271","992":"c73c8459"}[chunkId] + ".chunk.js";
};